import { render } from "./QualityIndexPanel.vue?vue&type=template&id=32dba0f2&scoped=true"
import script from "./QualityIndexPanel.vue?vue&type=script&lang=js"
export * from "./QualityIndexPanel.vue?vue&type=script&lang=js"

import "./QualityIndexPanel.vue?vue&type=style&index=0&id=32dba0f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dba0f2"]])

export default __exports__